/**
 * 都道府県から市区町村読み込み
 */
jQuery(function () {
    const cacheStore = {};

    $('select.select-state').each(function () {
        const $selectState = $(this);
        const sNo = $selectState.data('number');
        const $selectCity = $(`select.select-city[data-number="${sNo}"]`);
        const emptyOption = $selectCity.find('option').first(); // 先頭の「市区町村を選択」のoptionタグ

        const empty = function () {
            $selectCity.empty();
            $selectCity.append(emptyOption);
        };

        $selectState.on('change', function () {
            const state = $selectState.val();
            if (!$.isNumeric(state)) {
                // 先頭の「都道府県を選択」を選んだら市区町村を空にして終了
                empty();
                return;
            }

            if (cacheStore[state]) {
                // キャッシュ済みなら市区町村にセットして終了
                empty();
                $selectCity.append(cacheStore[state]);
                return;
            }

            $.ajax({
                type: 'get',
                url: `/city-codes/${state}`,
            }).then(
                function (res) {
                    // キャッシュして市区町村にセット
                    cacheStore[state] = res.cities.map(
                        (city) => `<option value="${city.id}">${city.name}</option>`
                    );
                    empty();
                    $selectCity.append(cacheStore[state]);
                },
                function () {
                    alert('市区町村を取得できませんでした。');
                }
            );
        });
    });
});
